module.exports = __webpack_public_path__ + "img/gurukreator.3bb9a020.png";